export function isAiSalesPreview(): boolean {
  if (import.meta.env.VITE_AI_SALES_USE_MOCK === 'true') return true;
  try {
    return sessionStorage.getItem('ai-sales-preview') === '1';
  } catch {
    return false;
  }
}

export function setAiSalesPreview(on: boolean): void {
  try {
    if (on) sessionStorage.setItem('ai-sales-preview', '1');
    else sessionStorage.removeItem('ai-sales-preview');
  } catch {
    /* ignore */
  }
}
